"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function RevLine(props) {
  var id = props.id,
    title = props.schema.title;
  return react_1.default.createElement(Wrapper, {
    id: id
  }, title ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: "line"
  }), react_1.default.createElement("div", {
    className: "text"
  }, title), react_1.default.createElement("div", {
    className: "line"
  })) : react_1.default.createElement("div", {
    className: "line"
  }));
}
exports.default = RevLine;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin: 20px 0px 0px;\n\n  .text {\n    margin: 0 10px;\n    font-weight: bold;\n  }\n\n  .line {\n    flex: 1;\n    height: 2px;\n    background-color: #aaa;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 20px 0px 0px;\n\n  .text {\n    margin: 0 10px;\n    font-weight: bold;\n  }\n\n  .line {\n    flex: 1;\n    height: 2px;\n    background-color: #aaa;\n  }\n"])));
var templateObject_1;